/**
 * businessDays.ts — Helpers para evaluar antigüedad de la TRM.
 *
 * No incluye festivos colombianos (mantenemos el módulo libre de
 * dependencias). Usamos lunes-viernes como aproximación razonable; el
 * margen de error (~10 festivos/año) es aceptable para un umbral de 5
 * días hábiles que sirve como advertencia, no como cálculo legal.
 */

/** Días hábiles (lunes-viernes) entre dos fechas, inclusive del inicio, exclusivo del fin. */
export function businessDaysBetween(from: Date, to: Date): number {
  if (!(from instanceof Date) || !(to instanceof Date)) return 0;
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 0;
  if (to <= from) return 0;
  let count = 0;
  const cur = new Date(from);
  cur.setHours(0, 0, 0, 0);
  const end = new Date(to);
  end.setHours(0, 0, 0, 0);
  while (cur < end) {
    const d = cur.getDay();
    if (d !== 0 && d !== 6) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}

/** ¿Pasaron más de `maxBusinessDays` desde `trmDate` hasta hoy? */
export function isTrmOutdated(trmDate: string | Date | null | undefined, maxBusinessDays = 5): boolean {
  if (!trmDate) return false;
  const d = trmDate instanceof Date ? trmDate : new Date(trmDate);
  if (Number.isNaN(d.getTime())) return false;
  return businessDaysBetween(d, new Date()) > maxBusinessDays;
}

/** Formato dd/mm/yyyy para mostrar en UI/Excel (es-CO). */
export function formatTrmDate(trmDate: string | Date | null | undefined): string {
  if (!trmDate) return "—";
  const d = trmDate instanceof Date ? trmDate : new Date(trmDate);
  if (Number.isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
